import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import useBreakpointIsDesktop from 'hooks/useBreakpointIsDesktop';
import React from 'react';
import NextLink from 'next/link';
import { TextButton } from '@buoyhealth/common.buoy-button';

const AlphabetNav = ({
  enabledLetters = ALPHABET,
  value,
  hrefBase,
}: {
  enabledLetters?: string[];
  value?: string;
  hrefBase?: string;
}) => {
  const isDesktop = useBreakpointIsDesktop();
  return (
    <Tabs
      value={value || false}
      variant={isDesktop ? undefined : 'scrollable'}
      scrollButtons={!isDesktop}
      className="px-3"
      centered={isDesktop}
    >
      {ALPHABET.map((letter) => (
        <Tab
          component={(componentProps) =>
            hrefBase ? (
              <NextLink
                passHref
                prefetch={false}
                scroll={false}
                {...componentProps}
              />
            ) : (
              <TextButton withBuoyTheme {...componentProps} />
            )
          }
          href={
            enabledLetters.includes(letter)
              ? hrefBase
                ? `${hrefBase}${letter}`
                : `#${letter}`
              : ''
          }
          key={letter}
          disabled={!enabledLetters.includes(letter)}
          value={letter}
          className="font-primary-main min-w-[35px] p-3 text-blue-50 hover:bg-gray-0 hover:text-blue-70"
          label={letter}
          aria-label={`Navigate to ${letter}`}
        />
      ))}
    </Tabs>
  );
};

const ALPHABET = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export default AlphabetNav;
